import { render, staticRenderFns } from "./Perfiles.vue?vue&type=template&id=1f725ab4&"
import script from "./Perfiles.vue?vue&type=script&lang=js&"
export * from "./Perfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports